const { HTTPConnection } = require('./http-connection');
const { HTTPTransportSession } = require('./http-transport-session');

if (BUILD_ENV.TARGET_BROWSER) {
  module.exports.HTTPConnection = HTTPConnection;
  module.exports.HTTPTransportSession = HTTPTransportSession;
}
